import auth from '../../lib/Auth'
import { prompt } from '../../lib/bootbox'
import { AuthResponse, Location } from './types'
import { userActions } from '../../store/user/userSlice'
import { FeedbotDispatch } from '../../store/types'

const UNNAMED_USER = 'Anonymous user'

export function scheduleTokenRenewal(expiresIn: number | undefined, dispatch: FeedbotDispatch) {
  auth.scheduleTokenRenewal(expiresIn, async (authResponse: AuthResponse) => {
    const accessToken = authResponse.accessToken
    const idTokenPayload = authResponse.idTokenPayload

    dispatch(userActions.receiveAuthResponse({ accessToken, idTokenPayload }))
  })
}

export async function componentDidMount(
  location: Location,
  dispatch: FeedbotDispatch,
  setShow: (show: boolean) => void,
  setReferrer: (referrer?: string) => void
) {
  try {
    const authResponse = await setAuthResponse(location, dispatch, setReferrer)

    if (!authResponse) {
      return
    }

    const expiresIn = authResponse.expiresIn
    const accessToken = authResponse.accessToken
    const idTokenPayload = authResponse.idTokenPayload

    dispatch(userActions.receiveAuthResponse({ accessToken, idTokenPayload }))
    scheduleTokenRenewal(expiresIn, dispatch)
  } catch (error) {
    console.error(error)
    setShow(true)
  }
}

async function setLocalStorage(token: string, prevToken: string | null) {
  if (prevToken === token) {
    return localStorage.getItem('name')
  }

  const name =
    (await prompt({
      title: 'Welcome to the Feedyou Platform',
      message:
        'Please enter your name so we can use it to sign comments or changes that you will make.'
    })) || UNNAMED_USER

  localStorage.setItem('name', name)
  localStorage.setItem('accessToken', token)

  return name
}

async function saveAuth(token: string | null, dispatch: FeedbotDispatch): Promise<void> {
  if (!token) {
    return
  }

  const name = await setLocalStorage(token, localStorage.getItem('accessToken'))

  dispatch(
    userActions.receiveAuthResponse({
      accessToken: token,
      tokenLogin: true,
      idTokenPayload: { name: name ?? '', sub: token }
    })
  )
}

async function setAuthResponse(
  location: Location,
  dispatch: FeedbotDispatch,
  setReferrer: (referrer?: string) => void
): Promise<AuthResponse | undefined> {
  if (location.state && location.state?.search) {
    const token = new URLSearchParams(location.state.search).get('token')

    if (token) {
      await saveAuth(token, dispatch)
      return undefined
    }
  }

  const hash = window.location.hash
  if (/#access_token|#error/.test(hash)) {
    const authResponse = await auth.handleAuthentication(hash)
    setReferrer(authResponse.state)

    return authResponse
  }

  return await auth.checkSession()
}
